{
  "version": 1,
  "asset_id": "0cb47adb-3dfc-4604-8fbb-8f0fceb3c4d1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0cb47adb-3dfc-4604-8fbb-8f0fceb3c4d1/crystal-river-blue-shingle-roof-destination-roofing-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0cb47adb-3dfc-4604-8fbb-8f0fceb3c4d1/crystal-river-blue-shingle-roof-destination-roofing-1200w.webp",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-1200w.webp",
  "size": 92848,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:47Z"
}
